import { render } from "./ChooseTenant.vue?vue&type=template&id=346b78b4&scoped=true&ts=true"
import script from "./ChooseTenant.vue?vue&type=script&lang=ts"
export * from "./ChooseTenant.vue?vue&type=script&lang=ts"

import "./ChooseTenant.vue?vue&type=style&index=0&id=346b78b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346b78b4"]])

export default __exports__